import { useLang } from "@/i18n/LanguageContext";

export default function Marquee() {
  const { t } = useLang();
  const words = [0, 1, 2, 3, 4, 5].map((i) => t(`marquee.${i}`));
  const content = [...words, ...words];
  return (
    <div data-testid="marquee-section" className="border-y border-[#1A1A1A] py-6 overflow-hidden bg-[#050505]">
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {content.map((w, i) => (
              <span key={`${half}-${i}`} className="flex items-center shrink-0">
                <span className="font-display text-3xl md:text-5xl uppercase text-[#E5E5E5]/80 px-8">{w}</span>
                <span className="text-[#75FB4E] text-xl">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
